'use strict';

var nodeToJson = require('./node2json');
var xmlToNodeobj = require('./xmlstr2xmlnode');
var x2xmlnode = require('./xmlstr2xmlnode');
var buildOptions = require('./util').buildOptions;
var validator = require('./validator');
exports.parse = function (xmlData) {
  var givenOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var validationOption = arguments.length > 2 ? arguments[2] : undefined;
  if (validationOption) {
    if (validationOption === true) validationOption = {};
    var result = validator.validate(xmlData, validationOption);
    if (result !== true) {
      throw Error(result.err.msg);
    }
  }
  if (givenOptions.parseTrueNumberOnly && givenOptions.parseNodeValue !== false && !givenOptions.numParseOptions) {
    givenOptions.numParseOptions = {
      leadingZeros: false
    };
  }
  var options = buildOptions(givenOptions, x2xmlnode.defaultOptions, x2xmlnode.props);
  var traversableObj = xmlToNodeobj.getTraversalObj(xmlData, options);
  //print(traversableObj, "  ");
  return nodeToJson.convertToJson(traversableObj, options);
};
exports.convertTonimn = require('./nimndata').convert2nimn;
exports.getTraversalObj = xmlToNodeobj.getTraversalObj;
exports.convertToJson = nodeToJson.convertToJson;
exports.convertToJsonString = require('./node2json_str').convertToJsonString;
exports.validate = validator.validate;
exports.j2xParser = require('./json2xml');
exports.parseToNimn = function (xmlData, schema, options) {
  return exports.convertTonimn(exports.getTraversalObj(xmlData, options), schema, options);
};
function print(xmlNode, indentation) {
  if (xmlNode) {
    console.log(indentation + "{");
    console.log(indentation + "  \"tagName\": \"" + xmlNode.tagname + "\", ");
    if (xmlNode.parent) {
      console.log(indentation + "  \"parent\": \"" + xmlNode.parent.tagname + "\", ");
    }
    console.log(indentation + "  \"val\": \"" + xmlNode.val + "\", ");
    console.log(indentation + "  \"attrs\": " + JSON.stringify(xmlNode.attrsMap, null, 4) + ", ");
    if (xmlNode.child) {
      console.log(indentation + "\"child\": {");
      var indentation2 = indentation + indentation;
      Object.keys(xmlNode.child).forEach(function (key) {
        var node = xmlNode.child[key];
        if (Array.isArray(node)) {
          console.log(indentation + "\"" + key + "\" :[");
          node.forEach(function (item, index) {
            //console.log(indentation + " \""+index+"\" : [")
            print(item, indentation2);
          });
          console.log(indentation + "],");
        } else {
          console.log(indentation + " \"" + key + "\" : {");
          print(node, indentation2);
          console.log(indentation + "},");
        }
      });
      console.log(indentation + "},");
    }
    console.log(indentation + "},");
  }
}